import React from "react";
import Lottie from "lottie-react";
import groovyWalkAnimation from "./moonlottie.json";

const MoonLotties = () => <Lottie className="-ms-8  !w-[31rem]" animationData={groovyWalkAnimation}

loop={true} />;

export default MoonLotties;